import { createContext } from 'react';
export const CopilotChannelContext = /*#__PURE__*/createContext({
  channel: undefined,
  channelState: {
    appContext: {},
    isNavCopilotAvailable: false,
    isWidgetOpen: false,
    isWidgetActive: false,
    layoutType: 'panel'
  }
});